/* This file is autogenerated, see readme.md for instructions */
import LayoutSvgIcon from '@bloomreach/banana-theme/icons/layout.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const LayoutIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <LayoutSvgIcon />
    </Icon>
  );
});

LayoutIcon.displayName = 'LayoutIcon';

export default LayoutIcon;
